interface ThemeState {
  themeColor: string;
}

type Action = {
  type: string;
  payload: string;
};

const initialState = {
  themeColor: "Light",
};

export const ThemeSlice = (
  state: ThemeState = initialState,
  action: Action
) => {
  switch (action.type) {
    case "THEME_COLOR": {
      return {
        ...state,
        themeColor: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
export default ThemeSlice;
